import { PageData, Post } from "@/common/models";
import Alert from "@/components/Alert";
import Layout from "@/components/Layout";
import MetaTags from "@/components/MetaTags";
import Pagination from "@/components/Pagination";
import PostGridItem from "@/components/post/PostGridItem";
import { getPosts } from "@/lib/PostAPI";
import { GetServerSideProps } from "next";
import Head from "next/head";
import { ReactElement } from "react";

export default function Surveys({
  page,
  locale
}: {
  page: PageData<Post>;
  locale: string;
}) {
  const content = () => {
    if (page.list.length === 0) {
      return <Alert message="No posts found" />;
    }

    return (
      <>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {page.list.map((p, i) => {
            return (
              <div key={p.id} className="col">
                <PostGridItem value={p} />
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <>
      <Head>
        <title>Surveys</title>
        <MetaTags
          title={"Surveys"}
          coanical={`${process.env.NEXT_PUBLIC_BASE_URL}${
            locale === "en" ? "/en" : ""
          }/surveys`}
        />
      </Head>
      <div className="container py-4 mb-5">
        <h1 className="">Surveys</h1>
        {page.total_page > 0 && (
          <div className="text-muted mb-4">{`Page ${page.current_page + 1} of ${
            page.total_page
          }`}</div>
        )}
        {content()}

        <div className="mt-3 d-flex justify-content-end">
          <Pagination
            basePath={`/surveys`}
            currentPage={page.current_page + 1}
            totalPage={page.total_page}
          />
        </div>
      </div>
    </>
  );
}

Surveys.getLayout = (page: ReactElement) => {
  return <Layout overrideDefaultMeta>{page}</Layout>;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const locale = context.locale;

  const { page } = context.query;

  try {
    if (locale) {
      const p = typeof page === "string" ? parseInt(page) - 1 : undefined;

      const pageData = await getPosts(
        {
          type: "SURVEY",
          page: p
        },
        locale === "en" ? "EN" : "MM"
      );

      return {
        props: {
          page: pageData,
          locale: locale
        }
      };
    } else {
      return {
        redirect: {
          statusCode: 302,
          destination: "/"
        }
      };
    }
  } catch (error) {}
  return {
    notFound: true
  };
};
